import { Trans } from "react-i18next";
import { ConfirmationDialog } from "../../../components";
import { useLocalization } from "../../../hooks/useLocalization";
import { useRemoveWhitelistedEmails } from "../hooks/useRemoveWhitelistedEmails";

interface RemoveWhitelistedEmailProps {
  open: boolean;
  onClose: () => void;
  licenseId: string;
  removedEmail: string;
  licenseName: string;
}

export const RemoveWhitelistedEmail: React.FC<RemoveWhitelistedEmailProps> = ({
  open,
  onClose,
  licenseId,
  removedEmail,
  licenseName,
}) => {
  const { t } = useLocalization();

  const removeWhitelistedEmailsMutation = useRemoveWhitelistedEmails();

  const onRemoveSuccess = () => {
    onClose();
  };

  const onRemove = () => {
    removeWhitelistedEmailsMutation.mutate({
      licenseId: licenseId,
      emails: [removedEmail],
      onSuccess: onRemoveSuccess,
    });
  };

  return (
    <ConfirmationDialog.Root maxWidth="xs" onClose={onClose} open={open}>
      <ConfirmationDialog.Title showIcon={true}>
        {t("licenses.removeFromWhitelistDialog.title")}
      </ConfirmationDialog.Title>
      <ConfirmationDialog.Content error={removeWhitelistedEmailsMutation.error}>
        <ConfirmationDialog.Text>
          <Trans
            components={{ strong: <strong /> }}
            i18nKey="licenses.removeFromWhitelistDialog.confirmation"
            values={{ removedEmail, licenseName }}
          />
        </ConfirmationDialog.Text>
      </ConfirmationDialog.Content>
      <ConfirmationDialog.Actions>
        <ConfirmationDialog.Button onClick={onClose} variant="contained">
          {t("licenses.removeFromWhitelistDialog.cancel")}
        </ConfirmationDialog.Button>
        <ConfirmationDialog.Button
          disabled={removeWhitelistedEmailsMutation.isPending}
          isLoading={removeWhitelistedEmailsMutation.isPending}
          loadingText={t("licenses.removeFromWhitelistDialog.removing")}
          onClick={onRemove}
          variant="secondary"
        >
          {t("licenses.removeFromWhitelistDialog.remove")}
        </ConfirmationDialog.Button>
      </ConfirmationDialog.Actions>
    </ConfirmationDialog.Root>
  );
};
